import { em } from 'polished'
import styled from 'styled-components'

import { Col } from 'styles/components/layout'

export const ColContent = styled(Col)`
  position: relative;
  padding-top: ${em(40)};
  padding-bottom: ${em(450)};

  ${p => p.theme.mq.upMd} {
    padding-top: 0;
    padding-bottom: 0;
    display: flex;
    height: ${p => p.theme.blocks.heightBlock500};
    align-items: center;
  }
`

export const EarthWrapper = styled.div`
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: ${em(800)};
  height: ${em(450)};

  ${p => p.theme.mq.upMd} {
    transform: translateX(0);
    left: 30%;
  }

  ${p => p.theme.mq.upLg} {
    left: auto;
    right: 5%;
  }
`
